import PropTypes from 'prop-types';
import React from 'react';
import NumberFormat from 'react-number-format';

import { LoaderCircle } from 'lucide-react';
import { cn } from 'twyne-new.ui';

export default function Summary({ cards, isLoading, className }) {
  return <div className={cn('flex items-center gap-2 p-2 twy-bg-base max-md:flex-wrap', className)}>
    {cards.map((props, idx) => <SummaryCard key={idx} isLoading={isLoading} {...props} />)}
  </div>
}

function SummaryCard({ title, value, money, isLoading }) {
  value = value && value.isComparison ? value.valueA : value
  return <div className='p-3 rounded-sm w-full flex flex-col gap-4 h-19 twy-bg-base-accent shadow-sm truncate max-md:w-auto max-md:grow max-md:basis-[calc((100%-1rem)/3)] max-md:p-2 max-md:gap-2 max-md:h-auto'>
    {isLoading ? <Loader /> : <>
      <div className='truncate max-w-full max-md:text-sm'>{title}</div>
      <span className='font-bold text-xl twy-text-base-accent max-md:text-base max-md:truncate'>
        {value ? <Format money={money}>{value}</Format> : '--'}
      </span>
    </>}
  </div>
}

const Loader = () => <div className='w-full h-full flex items-center justify-center'>
  <LoaderCircle size='30' className='animate-spin' />
</div>

SummaryCard.propTypes = {
  title: PropTypes.any,
  value: PropTypes.any,
  isLoading: PropTypes.bool,
  money: PropTypes.bool
}
SummaryCard.defaultProps = {
  isLoading: true,
  money: false
}

Summary.propTypes = {
  isLoading: PropTypes.bool,
  cards: PropTypes.array
}
Summary.defaultProps = {
  isLoading: true
}

function Format({ children: value, money }) {
  const props = {
    value,
    displayType: "text",
    thousandSeparator: ","
  }
  if (money) {
    props.decimalSeparator = "."
    props.prefix = '$'
    props.decimalScale = 2
    props.fixedDecimalScale = true
    props.className = value < 0 ? 'text-red-400 dark:text-red-300' : 'text-green-400 dark:text-green-300'
  }

  return <NumberFormat {...props} />
}

export {
  SummaryCard,
}
